import { Box } from '@mui/material'
import { forwardRef, RefObject } from 'react'

type Props = {
  handleScroll: () => void
  widthRef: RefObject<HTMLDivElement>
}

export const TopScrollbar = forwardRef<HTMLDivElement, Props>(({ handleScroll, widthRef }, ref) => (
  <Box
    onScroll={handleScroll}
    ref={ref}
    sx={{ overflowX: 'auto' }}
  >
    <Box
      ref={widthRef}
      sx={{
        display: 'block',
        minHeight: '1px',
      }}
    />
  </Box>
))

TopScrollbar.displayName = 'TopScrollbar'
